import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {CustomButtonComponent} from "../../../../shared/components/custom-button/custom-button";
import {CustomSearchComponent} from "../../../../shared/components/custom-search/custom-search";
import {MatCard, MatCardContent} from "@angular/material/card";
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow, MatRowDef, MatTable, MatTableDataSource, MatTableModule
} from "@angular/material/table";
import {MatIconButton} from "@angular/material/button";
import {MatSort, MatSortHeader} from "@angular/material/sort";
import {MatPaginator, MatPaginatorIntl} from '@angular/material/paginator';
import {SistemaService} from '../../services/system-service';
import {ToastService} from '../../../../core/services/toast/toast-service';
import {LoaderService} from '../../../../core/services/loader/loader-service';
import {Router} from '@angular/router';
import {Sistema, SistemaExcel} from '../../model/sistema';
import {TableUtil} from '../../../../shared/utils/tableUtil';
import {CustomModalComponent} from '../../../../shared/components/custom-modal/custom-modal';
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {InputCustom} from '../../../../shared/components/input-custom/input-custom';
import {KeyStorageUtil} from '../../../../shared/utils/keystorage';
import {SidebarService} from '../../../../core/services/sidebar/sidebar-service';

@Component({
  selector: 'app-system-config',
  standalone: true,
  imports: [
    MatCard,
    MatCardContent,
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderRowDef,
    MatIconButton,
    MatPaginator,
    MatRow,
    MatRowDef,
    MatSort,
    MatSortHeader,
    MatTable,
    MatTableModule,
    CustomButtonComponent,
    CustomModalComponent,
    ReactiveFormsModule,
    InputCustom,
    CustomSearchComponent,
    FormsModule,
  ],
  templateUrl: './system-config.html',
  styleUrl: './system-config.css'
})
export class SystemConfig implements OnInit, AfterViewInit {

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;


  displayedColumns: string[] = ['nombre', 'descripcion', 'ruta', 'icono', 'orden', 'accion'];
  public sistemas: Sistema[] = [];
  sistemaSelected!: Sistema;
  isModalOpen: boolean = false;
  isModalOpenEdit: boolean = false;
  sistemaForm!: FormGroup;
  sistemaEditForm!: FormGroup;
  submitted: boolean = false;
  dataSource = new MatTableDataSource<Sistema>([]);
  isUploading = false;
  fileUrl!: string | null;
  uploadFile: boolean = false;
  fileName: string = '';
  searchText: string = '';
  private isExporting = false;

  constructor(
    private paginatorIntl: MatPaginatorIntl,
    private sistemaService: SistemaService,
    private toastService: ToastService,
    private loaderService: LoaderService,
    private router: Router,
    private formBuilder: FormBuilder,
    private sidebarService: SidebarService
  ) {
    this.paginatorIntl.itemsPerPageLabel = 'Filas por página:';
    this.paginatorIntl.lastPageLabel = 'Última página';
    this.paginatorIntl.firstPageLabel = 'Primera página';
    this.paginatorIntl.nextPageLabel = 'Página siguiente';
    this.paginatorIntl.previousPageLabel = 'Página anterior';

    this.paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length === 0 || pageSize === 0) {
        return `0 de ${length}`;
      }

      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      const endIndex = startIndex < length ?
        Math.min(startIndex + pageSize, length) :
        startIndex + pageSize;

      return `${startIndex + 1} - ${endIndex} de ${length}`;
    };

    this.paginatorIntl.changes.next();
  }

  ngOnInit() {
    this.getSistemas();
    this.initForm();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = (item: any, property: string) => {
      return item[property];
    };
  }

  onSearchKeyup(event: KeyboardEvent) {
    this.reapplyCurrentFilters();
  }

  navigateToMenu() {
    this.router.navigate(['/menu']);
  }



  getSistemas() {
    this.loaderService.showLoader();
    this.sistemaService.findAll().subscribe({
      next: (res: Sistema[]) => {
        this.sistemas = res;
        this.dataSource.data = this.sistemas;
        KeyStorageUtil.setItem('systems', res);
        let processedSystems: Sistema[];
        processedSystems = res;
        sessionStorage.setItem(
          'sidebarSystems',
          JSON.stringify(processedSystems)
        );
        this.sidebarService.notifySystemsUpdated(processedSystems);
        this.reapplyCurrentFilters();
        this.loaderService.hideLoader();
      },
      error: (error) => {
        this.loaderService.hideLoader();
        console.error('Error al obtener sistemas:', error);
      }
    });
  }

  private reapplyCurrentFilters() {
    this.dataSource.filterPredicate = (data: Sistema, filter: string) => {
      let match = true;
      const lowerCaseFilter = this.searchText.trim().toLowerCase();

      if (this.searchText) {
        const searchMatch =
          data.nombre?.toLowerCase().includes(lowerCaseFilter) ||
          data.descripcion?.toLowerCase().includes(lowerCaseFilter) ||
          data.ruta?.toLowerCase().includes(lowerCaseFilter) ||
          data.icono?.toLowerCase().includes(lowerCaseFilter) ||
          (data.orden?.toString() || '').includes(lowerCaseFilter);

        match = match && searchMatch;
      }

      return match;
    };

    this.dataSource.filter = this.searchText.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  exportarExcel() {
    if (this.isExporting) {
      return;
    }

    this.isExporting = true;
    this.loaderService.showLoader();

    try {
      let datos: SistemaExcel[] = [];
      this.sistemas.forEach(element => {

        let data = {} as SistemaExcel;
        data.Nombre = element.nombre;
        data.Descripcion = element.descripcion;
        data.Ruta = element.ruta;
        data.Icono = element.icono;
        if (element.orden != null) {
          data.Orden = element.orden;
        }

        datos.push(data);
      });
      TableUtil.exportToExcelModel(datos);
      this.toastService.showToast('Excel exportado correctamente', 'success');
    }catch (e) {
      this.toastService.showToast('Error al exportar Excel', 'error');
      console.error('Error al exportar Excel:', e);
    }finally {
      this.loaderService.hideLoader();

      setTimeout(() => {
        this.isExporting = false;
      }, 2000);
    }
  }

  onAddSystem() {
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
    this.submitted = false;
    this.sistemaForm.reset();
    this.isModalOpenEdit = false;
    this.sistemaEditForm.reset();
    this.handleRemovesFile();
  }

  saveSystem() {
    this.submitted = true;
    if (this.sistemaForm.valid) {
      this.loaderService.showLoader();
      this.sistemaService.addSistema({
        nombre: this.sistemaForm.value.nombre,
        img: '',
        descripcion: '',
        ruta: '',
        icono: '',
        orden: null
      }).subscribe({
        next: (value) => {
          try {
            this.closeModal();
            this.getSistemas();
            this.toastService.showToast('Sistema agregado correctamente.', "success");
          } catch (e) {
            console.error('Error al procesar la respuesta del sistema:', e);
            this.toastService.showToast('Ocurrió un error inesperado.', 'error');
          } finally {
            this.loaderService.hideLoader();
          }
        },
        error: (err) => {
          console.error('Error al agregar sistema:', err);
          this.toastService.showToast('Ocurrió un error al agregar el sistema.', 'error');
          this.loaderService.hideLoader();
        }
      });
    }
  }

  onOpenModalEditUser(sistema: Sistema) {
    this.loaderService.showLoader();
    this.sistemaSelected = sistema;
    this.isModalOpenEdit = true;
    if(sistema && sistema.id) {
      this.sistemaEditForm.patchValue({
        nombreEdit: sistema.nombre || '',
        descripcion: sistema.descripcion || '',
        ruta: sistema.ruta || '',
        icono: sistema.icono || '',
        orden: sistema.orden !== null ? sistema.orden : null,
        img: sistema.img || '',
      });
      if(sistema.img !== "") this.uploadFile = true;
    }
    this.loaderService.hideLoader();
  }


  editSaveSystem(){
    this.submitted = true;
    this.sistemaEditForm.markAllAsTouched();
    if (this.sistemaEditForm.invalid) {
      return;
    }
    this.loaderService.showLoader();


    this.sistemaService.update({
      id : this.sistemaSelected.id,
      nombre : this.sistemaEditForm.get('nombreEdit')?.value || '',
      descripcion : this.sistemaEditForm.get('descripcion')?.value || '',
      ruta : this.sistemaEditForm.get('ruta')?.value || '',
      icono : this.sistemaEditForm.get('icono')?.value || '',
      orden : this.sistemaEditForm.get('orden')?.value !== null ? this.sistemaEditForm.get('orden')?.value : null,
      img: this.sistemaEditForm.get('img')?.value || ''
    }).subscribe({
      next: (value) => {
        this.closeModal();
        this.getSistemas();
        this.loaderService.hideLoader();
        this.toastService.showToast('Sistema actualizado correctamente.',"success");
      },
      error: (err) => {
        this.loaderService.hideLoader();
        console.error('Error al actualizar sistema:', err);
        this.toastService.showToast('Ocurrió un error al actualizar el sistema.','error');
      }
    });

  }


  initForm() {
    this.sistemaForm = this.formBuilder.group({
      nombre: new FormControl('', [Validators.required, Validators.maxLength(60)]),
    });

    this.sistemaEditForm = this.formBuilder.group({
      nombreEdit: new FormControl('', [Validators.required, Validators.maxLength(30)]),
      descripcion: new FormControl('', [Validators.required, Validators.maxLength(100)]),
      ruta: new FormControl('', [Validators.required, Validators.maxLength(300)]),
      icono: new FormControl('', [Validators.required, Validators.maxLength(40)]),
      img: new FormControl(''),
      orden: new FormControl<number | null>(null, [
        Validators.required,
        Validators.pattern('^[0-9]*$'),
        Validators.max(9999999)
      ])
    });
  }
  get nombre() {
    return this.sistemaForm.get('nombre');
  }
  get nombreEdit() {
    return this.sistemaEditForm.get('nombreEdit');
  }
  get descripcion() {
    return this.sistemaEditForm.get('descripcion');
  }
  get ruta() {
    return this.sistemaEditForm.get('ruta');
  }
  get icono() {
    return this.sistemaEditForm.get('icono');
  }
  get orden() {
    return this.sistemaEditForm.get('orden');
  }

  handleRemovesFile() {
    if (this.fileInput && this.fileInput.nativeElement) {
      this.fileInput.nativeElement.value = null;
    }
    this.fileName = '';
    this.uploadFile = false;
    this.fileUrl = null;

  }

  getBase64( event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {

      console.error("No file selected.");
      return;
    }

    const file = input.files[0];

    const ALLOWED_FILE_TYPES = [
      'image/jpeg',
      'image/png',
      'image/svg+xml',
    ];

    if (!ALLOWED_FILE_TYPES.includes(file.type)) {
      this.toastService.showToast('Solo se permiten archivos JPG, PNG y SVG.', 'error');
      if (this.fileInput && this.fileInput.nativeElement) {
        this.fileInput.nativeElement.value = null;
      }
      return;
    }


    const maxW = 180;
    this.fileName = input.files[0].name
    const maxH = 180;

    const img = new Image();
    img.src = URL.createObjectURL(file);

    img.onload = () => {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      if (!context) {
        console.error("Failed to get 2D context from canvas.");
        return;
      }

      const { width: iw, height: ih } = img;
      const scale = Math.min(maxW / iw, maxH / ih);
      const iwScaled = iw * scale;
      const ihScaled = ih * scale;

      canvas.width = iwScaled;
      canvas.height = ihScaled;

      context.drawImage(img, 0, 0, iwScaled, ihScaled);
      this.sistemaEditForm.get('img')?.setValue(canvas.toDataURL());

      URL.revokeObjectURL(img.src);
    };

    img.onerror = () => {
      console.error("Failed to load image.");
      URL.revokeObjectURL(img.src);
    };

    this.uploadFile = true;
  }

}
